/* unplugin-vue-components disabled */import { render } from "./about.vue?vue&type=template&id=2d81390d"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\vue\\hello_world\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__